import { featureCards } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-cinema-bg">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">为什么选择黄瓜影院</h2>
          <p className="text-sm text-cinema-muted">三大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureCards.map((card, i) => (
            <div
              key={i}
              className="group bg-cinema-card border border-cinema-border hover:border-cinema-gold/20 rounded-xl p-6 md:p-8 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-cinema-gold/10 text-cinema-gold mb-5 group-hover:bg-cinema-gold/20 transition-colors">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-3">{card.title}</h3>
              <p className="text-sm text-cinema-text-dim leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}